<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Son of the Brush</title>
<section epub:type="toc">
<p class="ctfront"><span epub:type="pagebreak" id="page_vii" title="vii"> Contents</span></p>
<p class="tx1" id="pz7-2"><a href="#/frontmatter#a01" id="r01">PRAISE FOR DEBT BOMB</a></p>
<p class="tx1-1"><a href="#/chapter01#a1" id="r1">CHAPTER 1</a></p>
<p class="tx1"><a href="#/chapter02#a2" id="r2">CHAPTER 2</a></p>
<p class="tx1"><a href="#/chapter03#a3" id="r3">CHAPTER 3</a></p>
<p class="tx1"><a href="#/chapter04#a4" id="r4">CHAPTER 4</a></p>
<p class="tx1"><span href="#/chapter05#a5" id="r5" title="Link target outside of Sample">CHAPTER 5</span></p>
<p class="tx1"><span href="#/chapter06#a6" id="r6" title="Link target outside of Sample">CHAPTER 6</span></p>
<p class="tx1"><span href="#/chapter07#a7" id="r7" title="Link target outside of Sample">CHAPTER 7</span></p>
<p class="tx1"><span href="#/chapter08#a8" id="r8" title="Link target outside of Sample">CHAPTER 8</span></p>
<p class="tx1"><span href="#/chapter09#a9" id="r9" title="Link target outside of Sample">CHAPTER 9</span></p>
<p class="tx1"><span href="#/chapter10#a10" id="r10" title="Link target outside of Sample">CHAPTER 10</span></p>
<p class="tx1"><span href="#/chapter11#a11" id="r11" title="Link target outside of Sample">CHAPTER 11</span></p>
<p class="tx1"><span href="#/chapter12#a12" id="r12" title="Link target outside of Sample">CHAPTER 12</span></p>
<p class="tx1"><span href="#/chapter13#a13" id="r13" title="Link target outside of Sample">CHAPTER 13</span></p>
<p class="tx1"><span href="#/chapter14#a14" id="r14" title="Link target outside of Sample">CHAPTER 14</span></p>
<p class="tx1"><span href="#/chapter15#a15" id="r15" title="Link target outside of Sample">CHAPTER 15</span></p>
<p class="tx1"><span href="#/chapter16#a16" id="r16" title="Link target outside of Sample">CHAPTER 16</span></p>
<p class="tx1"><span href="#/chapter17#a17" id="r17" title="Link target outside of Sample">CHAPTER 17</span></p>
<p class="tx1"><span href="#/chapter18#a18" id="r18" title="Link target outside of Sample">CHAPTER 18</span></p>
<p class="tx1"><span href="#/chapter19#a19" id="r19" title="Link target outside of Sample">CHAPTER 19</span></p>
<p class="tx1"><span href="#/chapter20#a20" id="r20" title="Link target outside of Sample">CHAPTER 20</span></p>
<p class="tx1"><span href="#/chapter21#a21" id="r21" title="Link target outside of Sample">CHAPTER 21</span></p>
<p class="tx1"><span href="#/chapter22#a22" id="r22" title="Link target outside of Sample">CHAPTER 22</span></p>
<p class="tx1"><span href="#/chapter23#a23" id="r23" title="Link target outside of Sample">CHAPTER 23</span></p>
<p class="tx1"><span href="#/chapter24#a24" id="r24" title="Link target outside of Sample">CHAPTER 24</span></p>
<p class="tx1"><span href="#/chapter25#a25" id="r25" title="Link target outside of Sample">CHAPTER 25</span></p>
<p class="tx1"><span href="#/chapter26#a26" id="r26" title="Link target outside of Sample">CHAPTER 26</span></p>
<p class="tx1"><span href="#/chapter27#a27" id="r27" title="Link target outside of Sample">CHAPTER 27</span></p>
<p class="tx1"><span href="#/chapter28#a28" id="r28" title="Link target outside of Sample">CHAPTER 28</span></p>
<p class="tx1"><span href="#/chapter29#a29" id="r29" title="Link target outside of Sample">CHAPTER 29</span></p>
<p class="tx1"><span href="#/chapter30#a30" id="r30" title="Link target outside of Sample">CHAPTER 30</span></p>
<p class="tx1"><span href="#/chapter31#a31" id="r31" title="Link target outside of Sample">CHAPTER 31</span></p>
<p class="tx1"><span href="#/chapter32#a32" id="r32" title="Link target outside of Sample">CHAPTER 32</span></p>
<p class="tx1"><span href="#/chapter33#a33" id="r33" title="Link target outside of Sample">CHAPTER 33</span></p>
<p class="tx1"><span href="#/chapter34#a34" id="r34" title="Link target outside of Sample">CHAPTER 34</span></p>
<p class="tx1"><span href="#/chapter35#a35" id="r35" title="Link target outside of Sample">CHAPTER 35</span></p>
<p class="tx1"><span href="#/chapter36#a36" id="r36" title="Link target outside of Sample">CHAPTER 36</span></p>
<p class="tx1"><span href="#/chapter37#a37" id="r37" title="Link target outside of Sample">CHAPTER 37</span></p>
<p class="tx1"><span href="#/chapter38#a38" id="r38" title="Link target outside of Sample">CHAPTER 38</span></p>
<p class="tx1"><span href="#/chapter39#a39" id="r39" title="Link target outside of Sample">CHAPTER 39</span></p>
<p class="tx1"><span href="#/chapter40#a40" id="r40" title="Link target outside of Sample">CHAPTER 40</span></p>
<p class="tx1"><span href="#/chapter41#a41" id="r41" title="Link target outside of Sample">CHAPTER 41</span></p>
<p class="tx1"><span href="#/chapter42#a42" id="r42" title="Link target outside of Sample">CHAPTER 42</span></p>
<p class="tx1"><span href="#/chapter43#a43" id="r43" title="Link target outside of Sample">CHAPTER 43</span></p>
<p class="tx1"><span href="#/chapter44#a44" id="r44" title="Link target outside of Sample">CHAPTER 44</span></p>
<p class="tx1"><span href="#/chapter45#a45" id="r45" title="Link target outside of Sample">CHAPTER 45</span></p>
<p class="tx1"><span href="#/chapter46#a46" id="r46" title="Link target outside of Sample">CHAPTER 46</span></p>
<p class="tx1"><span href="#/chapter47#a47" id="r47" title="Link target outside of Sample">CHAPTER 47</span></p>
<p class="tx1"><span href="#/chapter48#a48" id="r48" title="Link target outside of Sample">CHAPTER 48</span></p>
<p class="tx1"><span href="#/chapter49#a49" id="r49" title="Link target outside of Sample">CHAPTER 49</span></p>
<p class="tx1"><span href="#/chapter50#a50" id="r50" title="Link target outside of Sample">CHAPTER 50</span></p>
<p class="tx1"><span href="#/chapter51#a51" id="r51" title="Link target outside of Sample">CHAPTER 51</span></p>
<p class="tx1"><span href="#/chapter52#a52" id="r52" title="Link target outside of Sample">CHAPTER 52</span></p>
<p class="tx1-1"><span href="#/backmatter01#a53" id="r53" title="Link target outside of Sample"> EPILOGUE</span></p>
<p class="tx1"><span href="#/backmatter02#a54" id="r54" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contenttoc.vue?69c12a26